/* eslint-disable no-prototype-builtins */
import React, { useState, useEffect } from 'react'
import { useNavigate, useParams, Link } from 'react-router-dom'
import axios from 'axios'
import ReactHtmlParser from 'react-html-parser'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import CheckIcon from '@mui/icons-material/Check'
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined'

import { getPayload, getUserIdFromToken, getTokenFromLocalStorage } from '../../../helpers/storage'
import { standardButton } from '../../../helpers/buttons'
import { advisoryElementJSX } from '../../../helpers/commonJSX'
import { minimumBumbleAboutMe, minimumBumbleHobbies, minimumBumbleMedia, minimumBumblePrompts, minimumHingeAboutMe, minimumHingeHobbies, minimumHingeMedia, minimumHingePrompts, minimumOnboardingAboutMe, minimumOnboardingHobbies, minimumOnboardingMedia, minimumOnboardingPrompts, minimumTinderAboutMe, minimumTinderHobbies, minimumTinderMedia, minimumTinderPrompts } from '../../../helpers/variableDefaults'

export const submitAndSaveFeedbackButtonsJSX = (isFriendReview, profileReview, setProfileReview, width, errors, setErrors, loading, setLoading, saveSuccessful, setSaveSuccessful, submitReviewSuccessful, setSubmitReviewSuccessful, previousProfileReview, setPreviousProfileReview) => {


  const saveReviewButtonDisabled = () => {

    const mediaFeedbackIsNotEqual = () => {
      return profileReview.mediaFeedback.filter((mediaFeedbackItem, mediaFeedbackItemIndex) => mediaFeedbackItemIndex > previousProfileReview.mediaFeedback.length || mediaFeedbackItem.feedback !== previousProfileReview.mediaFeedback[mediaFeedbackItemIndex].feedback || mediaFeedbackItem.verdict !== previousProfileReview.mediaFeedback[mediaFeedbackItemIndex].verdict).length > 0
    }

    const promptFeedbackIsNotEqual = () => {
      return profileReview.bioFeedback.promptsFeedback.filter((promptFeedbackItem, promptFeedbackItemIndex) =>  promptFeedbackItemIndex > previousProfileReview.bioFeedback.promptsFeedback.length || promptFeedbackItem.feedback !== previousProfileReview.bioFeedback.promptsFeedback[promptFeedbackItemIndex].feedback || promptFeedbackItem.verdict !== previousProfileReview.bioFeedback.promptsFeedback[promptFeedbackItemIndex].verdict).length > 0
    }

    // console.log('mediaFeedbackIsNotEqual ->', mediaFeedbackIsNotEqual())
    // console.log('promptFeedbackIsNotEqual ->', promptFeedbackIsNotEqual())
    return (
      !(mediaFeedbackIsNotEqual())
      && !(promptFeedbackIsNotEqual())
      && profileReview.bioFeedback.aboutMeFeedback.feedback === previousProfileReview.bioFeedback.aboutMeFeedback.feedback
      && profileReview.bioFeedback.aboutMeFeedback.verdict === previousProfileReview.bioFeedback.aboutMeFeedback.verdict
      && profileReview.bioFeedback.vitalInfoFeedback.feedback === previousProfileReview.bioFeedback.vitalInfoFeedback.feedback
      && profileReview.bioFeedback.vitalInfoFeedback.verdict === previousProfileReview.bioFeedback.vitalInfoFeedback.verdict
      && profileReview.generalFeedback.vibe === previousProfileReview.generalFeedback.vibe
      && profileReview.generalFeedback.good === previousProfileReview.generalFeedback.good
      && profileReview.generalFeedback.notGood === previousProfileReview.generalFeedback.notGood
      && profileReview.generalFeedback.verdict === previousProfileReview.generalFeedback.verdict
    )
  }

  const allMediaHasVerdict = () => {
    return profileReview.mediaFeedback.filter(mediaFeedbackItem => mediaFeedbackItem.verdict.length > 0).length === profileReview.mediaFeedback.length
  }

  const allMediaHasFeedback = () => {
    return profileReview.mediaFeedback.filter(mediaFeedbackItem => mediaFeedbackItem.feedback.length > 0).length === profileReview.mediaFeedback.length
  }

  const allPromptsHasVerdict = () => {
    return profileReview.bioFeedback.promptsFeedback.filter(promptFeedbackItem => promptFeedbackItem.verdict.length > 0).length === profileReview.bioFeedback.promptsFeedback.length
  }

  const allPromptsHasFeedback = () => {
    return profileReview.bioFeedback.promptsFeedback.filter(promptFeedbackItem => promptFeedbackItem.feedback.length > 0).length === profileReview.bioFeedback.promptsFeedback.length
  }

  const aboutMeHasVerdict = () => {
    return (
      !(
        'aboutMe' in profileReview.bio && profileReview.bio.aboutMe.length > 0 
        || 'hobbies' in profileReview.bio && profileReview.bio.hobbies.length > 0 && profileReview.bio.hobbies.filter(hobbyItem => hobbyItem.length > 0).length > 0 
      )
      || profileReview.bioFeedback.aboutMeFeedback.verdict.length > 0
    )
  }

  const aboutMeHasFeedback = () => {
    return (
      !(
        'aboutMe' in profileReview.bio && profileReview.bio.aboutMe.length > 0 
        || 'hobbies' in profileReview.bio && profileReview.bio.hobbies.length > 0 && profileReview.bio.hobbies.filter(hobbyItem => hobbyItem.length > 0).length > 0 
      )
      || profileReview.bioFeedback.aboutMeFeedback.feedback.length > 0
    )
  }

  const vitalInfoHasVerdict = () => {
    return profileReview.bioFeedback.vitalInfoFeedback.verdict.length > 0
  }

  const vitalInfoHasFeedback = () => {
    return profileReview.bioFeedback.vitalInfoFeedback.feedback.length > 0
  }

  const allGeneralAnalysisHasFeedback = () => {
    return (
      profileReview.generalFeedback.vibe.length > 0
      && profileReview.generalFeedback.good.length > 0
      && profileReview.generalFeedback.notGood.length > 0
      && profileReview.generalFeedback.verdict.length > 0
    )
  }

  const submitReviewButtonDisabled = () => {

    return !(
      allMediaHasVerdict()
      &&
      (
        allMediaHasFeedback()
        || isFriendReview
      )
      && allPromptsHasVerdict()
      &&
      (
        allPromptsHasFeedback()
        || isFriendReview
      )
      && aboutMeHasVerdict()
      && 
      (
        aboutMeHasFeedback()
        || isFriendReview
      )
      && vitalInfoHasVerdict()
      && 
      (
        vitalInfoHasFeedback()
        || isFriendReview
      )
      && allGeneralAnalysisHasFeedback()
    )
  }

  const handleSaveProfileReview = async () => {
    console.log('handleSaveProfileReview runs')

    const objectToUpload = { 
      mediaFeedback: [ ...profileReview.mediaFeedback ], 
      bioFeedback: { ...profileReview.bioFeedback }, 
      generalFeedback: { ...profileReview.generalFeedback }, 
    }
    // console.log('objectToUpload ->', objectToUpload)

    try {
      setLoading(true)
      setErrors(false)
      const { data: savedProfileReview } = await axios.put(`${process.env.REACT_APP_SERVER_URL}/api/profile-reviews/${profileReview._id}/`, objectToUpload, {
        headers: {
          Authorization: `Bearer ${getTokenFromLocalStorage()}`,
        },
      })

      // setProfileReview({ ...completedProfileReview })
      setPreviousProfileReview(JSON.parse(JSON.stringify({ 
        ...previousProfileReview,
        mediaFeedback: [ ...profileReview.mediaFeedback ], 
        bioFeedback: { ...profileReview.bioFeedback }, 
        generalFeedback: { ...profileReview.generalFeedback },  
      })))

      setSaveSuccessful(true)
      setErrors(false)
      setLoading(false)

    } catch (err) {
      console.log('submit reviewer review error ->', err)

      setErrors(true)
      setLoading(false)
    }
  }

  const handleSubmitProfileReview = async () => {
    console.log('handleSubmitReviewerReview runs')

    // Media Feedback to Upload
    const mediaFeedbackToUpload = profileReview.mediaFeedback.map((mediaFeedbackItem, mediaFeedbackIndex) => {
      return {
        feedback: 'feedback' in mediaFeedbackItem && mediaFeedbackItem.feedback.trim().length > 0 ? mediaFeedbackItem.feedback.trim() : 'No Written Feedback',
        verdict: 'verdict' in mediaFeedbackItem && mediaFeedbackItem.verdict.trim().length > 0 ? mediaFeedbackItem.verdict : 'Somewhat',
      }
    })

    // Bio Feedback to Upload
    const bioFeedbackToUpload = { ...profileReview.bioFeedback }
    const promptsFeedbackToUpload = bioFeedbackToUpload.promptsFeedback.map((promptFeedbackItem, promptFeedbackIndex) => {
      return {
        feedback: 'feedback' in promptFeedbackItem && promptFeedbackItem.feedback.trim().length > 0 ? promptFeedbackItem.feedback.trim() : 'No Written Feedback',
        verdict: 'verdict' in promptFeedbackItem && promptFeedbackItem.verdict.trim().length > 0 ? promptFeedbackItem.verdict : 'Somewhat',
      }
    })
    bioFeedbackToUpload.promptsFeedback = [ ...promptsFeedbackToUpload ]
    bioFeedbackToUpload.vitalInfoFeedback = {
      feedback: 'vitalInfoFeedback' in bioFeedbackToUpload && 'feedback' in bioFeedbackToUpload.vitalInfoFeedback && bioFeedbackToUpload.vitalInfoFeedback.feedback.trim().length > 0 ? bioFeedbackToUpload.vitalInfoFeedback.feedback.trim() : 'No Written Feedback',
      verdict: 'vitalInfoFeedback' in bioFeedbackToUpload && 'verdict' in bioFeedbackToUpload.vitalInfoFeedback && bioFeedbackToUpload.vitalInfoFeedback.verdict.trim().length > 0 ? bioFeedbackToUpload.vitalInfoFeedback.verdict : 'Somewhat',
    }
    bioFeedbackToUpload.aboutMeFeedback = {
      feedback: 'aboutMeFeedback' in bioFeedbackToUpload && 'feedback' in bioFeedbackToUpload.aboutMeFeedback && bioFeedbackToUpload.aboutMeFeedback.feedback.trim().length > 0 ? bioFeedbackToUpload.aboutMeFeedback.feedback.trim() : 'No Written Feedback',
      verdict: 'aboutMeFeedback' in bioFeedbackToUpload && 'verdict' in bioFeedbackToUpload.aboutMeFeedback && bioFeedbackToUpload.aboutMeFeedback.verdict.trim().length > 0 ? bioFeedbackToUpload.aboutMeFeedback.verdict : 'Somewhat',
    }

    // General Feedback to Upload
    const generalFeedbackToUpload = { ...profileReview.generalFeedback }
    console.log('generalFeedbackToUpload ->', generalFeedbackToUpload)
    generalFeedbackToUpload.vibe = 'vibe' in generalFeedbackToUpload && generalFeedbackToUpload.vibe.trim().length > 0 ? generalFeedbackToUpload.vibe.trim() : 'No Written Feedback'
    generalFeedbackToUpload.good = 'good' in generalFeedbackToUpload && generalFeedbackToUpload.good.trim().length > 0 ? generalFeedbackToUpload.good.trim() : 'No Written Feedback'
    generalFeedbackToUpload.notGood = 'notGood' in generalFeedbackToUpload && generalFeedbackToUpload.notGood.trim().length > 0 ? generalFeedbackToUpload.notGood.trim() : 'No Written Feedback'
    generalFeedbackToUpload.verdict = 'verdict' in generalFeedbackToUpload && generalFeedbackToUpload.verdict.trim().length > 0 ? generalFeedbackToUpload.verdict.trim() : 'No Written Feedback'
    

    const objectToUpload = { 
      mediaFeedback: [ ...mediaFeedbackToUpload ], 
      bioFeedback: { ...bioFeedbackToUpload },  
      generalFeedback: { ...generalFeedbackToUpload }, 
      reviewSubmitted: true,
    }
    console.log('objectToUpload ->', objectToUpload)

    try {
      setLoading(true)
      setErrors(false)
      await axios.put(`${process.env.REACT_APP_SERVER_URL}/api/profile-reviews/${profileReview._id}/`, objectToUpload, {
        headers: {
          Authorization: `Bearer ${getTokenFromLocalStorage()}`,
        },
      })

      setSubmitReviewSuccessful(true)
      setProfileReview({ ...profileReview, reviewSubmitted: true })

      setErrors(false)
      setLoading(false)

    } catch (err) {
      console.log('submit reviewer review error ->', err)

      setErrors(true)
      setLoading(false)
    }
  }

  return (
    
    <Box
      sx={{
        mt: 1, mb: 1, 
        display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
      }}
    >
      {/* Buttons */}
      <Box sx={{ mt: 0, mb: 0, display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
        {standardButton(
          'Save', 
          'button',
          'contained',
          saveReviewButtonDisabled(),
          'secondary', 
          0,
          0,
          2,
          '80px',
          '45px',
          handleSaveProfileReview
        )}
        {standardButton(
          'Submit', 
          'button',
          'contained',
          submitReviewButtonDisabled(),
          'primary', 
          0,
          0,
          2,
          '80px',
          '45px',
          handleSubmitProfileReview
        )}
      </Box>

      {/* Advisory */}
      <Box
        sx={{
          mt: 1,
          display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-start', 
        }}
      >
        {/* Emoji Verdicts for all elements */}
        {advisoryElementJSX(
          `Emoji Verdicts for all elements`,
          allMediaHasVerdict() && allPromptsHasVerdict() && vitalInfoHasVerdict() && aboutMeHasVerdict()
        )}

        {/* Written Comments for all elements */}
        {!isFriendReview && advisoryElementJSX(
          `Written feedback for all elements`,
          allMediaHasFeedback() && allPromptsHasFeedback() && vitalInfoHasFeedback() && aboutMeHasFeedback()
        )}

        {/* All General Feedback Questions answered */}
        {advisoryElementJSX(
          `All General Analysis questions answered`,
          allGeneralAnalysisHasFeedback()
        )}
      </Box>
    </Box>
  )
}